import React from 'react';
import type { H2HDimension } from '../../types/headToHead';

function formatValue(value: number, format: H2HDimension['format']): string {
  switch (format) {
    case 'percent': return `${Math.round(value)}%`;
    case 'decimal': return value.toFixed(2);
    case 'integer':
    default: return String(Math.round(value));
  }
}

export function H2HDimensionRow({ dim }: { dim: H2HDimension }) {
  const noDataA = dim.coverage?.a === false;
  const noDataB = dim.coverage?.b === false;
  return (
    <div style={row} data-testid={`h2h-dim-${dim.key}`}>
      <div style={{ ...side, justifyContent: 'flex-end' }}>
        {noDataA ? (
          <span style={noData}>⌚ Sin datos</span>
        ) : (
          <span style={{ ...value, ...(dim.winner === 'a' ? winner : null) }}>{formatValue(dim.a, dim.format)}</span>
        )}
        {dim.winner === 'a' && <span data-testid="h2h-dim-check-a" style={check}>✓</span>}
      </div>
      <div style={label}>{dim.label}</div>
      <div style={{ ...side, justifyContent: 'flex-start' }}>
        {dim.winner === 'b' && <span data-testid="h2h-dim-check-b" style={check}>✓</span>}
        {noDataB ? (
          <span style={noData}>⌚ Sin datos</span>
        ) : (
          <span style={{ ...value, ...(dim.winner === 'b' ? winner : null) }}>{formatValue(dim.b, dim.format)}</span>
        )}
      </div>
    </div>
  );
}

const row: React.CSSProperties = { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 16px' };
const side: React.CSSProperties = { display: 'flex', alignItems: 'center', gap: 8, minWidth: 100 };
const label: React.CSSProperties = { color: '#888', textAlign: 'center', flex: 1 };
const value: React.CSSProperties = { color: '#ddd', fontWeight: 600, fontSize: 16 };
const winner: React.CSSProperties = { color: '#FFD700' };
const check: React.CSSProperties = { color: '#4caf50', fontWeight: 700 };
const noData: React.CSSProperties = { color: '#666', fontSize: 12, fontStyle: 'italic' };
